import { useAuth } from "@/hooks/use-auth";
import { useAuthStore } from "@/stores/auth-store";
import { LogOut } from "lucide-react";

export function UserMenu() {
	const { user } = useAuthStore();
	const { logoutMutation } = useAuth();

	if (!user) return null;

	return (
		<div className="flex items-center justify-between gap-2 rounded-lg bg-slate-50 px-3 py-2">
			<div className="min-w-0">
				<p className="truncate text-sm font-medium text-slate-700">{user.displayName}</p>
				<p className="text-xs text-slate-400">
					{user.role === "admin" ? "Администратор" : "Пользователь"}
				</p>
			</div>
			<button
				type="button"
				onClick={() => logoutMutation.mutate()}
				disabled={logoutMutation.isPending}
				title="Выйти"
				className="shrink-0 rounded p-1.5 text-slate-400 hover:bg-slate-200 hover:text-slate-600"
			>
				<LogOut className="h-4 w-4" />
			</button>
		</div>
	);
}
